import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { ThemeService } from 'app/core/services/theme.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  isSidebarClosed!: boolean;
  isDarkMode: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.isSidebarClosed = true;
    this.themeService.darkTheme$.subscribe((isDark) => {
      this.isDarkMode = isDark;
    });
  }

  toggleSidebar() {
    this.isSidebarClosed = !this.isSidebarClosed;
  }

  openSidebar() {
    this.isSidebarClosed = false;
  }

  logout(): void {
    this.authService.removeSession();
    this.router.navigate(['/login']);
  }
}
